package com.nonopn.skydome.common.app.home

import com.nonopn.skywatcher.common.api.AuthError
import com.nonopn.skywatcher.common.api.AuthErrorException
import com.nonopn.skywatcher.common.api.toAuthError
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.auth_error_email_already_used
import com.nonopn.skywatcher.common.app.res.auth_error_generic
import com.nonopn.skywatcher.common.app.res.auth_error_invalid_body
import com.nonopn.skywatcher.common.app.res.auth_error_invalid_credentials
import com.nonopn.skywatcher.common.app.res.auth_error_invalid_email
import com.nonopn.skywatcher.common.app.res.auth_error_invalid_reset_code
import com.nonopn.skywatcher.common.app.res.auth_error_password_too_short
import com.nonopn.skywatcher.common.app.res.auth_error_server
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.getString

internal fun AuthError.messageRes(): StringResource = when (this) {
    AuthError.InvalidCredentials -> Res.string.auth_error_invalid_credentials
    AuthError.EmailAlreadyUsed -> Res.string.auth_error_email_already_used
    AuthError.InvalidEmail -> Res.string.auth_error_invalid_email
    AuthError.PasswordTooShort -> Res.string.auth_error_password_too_short
    AuthError.InvalidResetCode -> Res.string.auth_error_invalid_reset_code
    AuthError.InvalidBody -> Res.string.auth_error_invalid_body
    AuthError.ServerError -> Res.string.auth_error_server
    AuthError.Generic -> Res.string.auth_error_generic
}

internal suspend fun authErrorException(error: AuthError, cause: Throwable? = null): AuthErrorException =
    AuthErrorException(error, getString(error.messageRes()), cause)

/** Translated error for the login / register screens, based on the backend `code` only. */
internal suspend fun Throwable.toTranslatedAuthError(): AuthErrorException =
    this as? AuthErrorException ?: authErrorException(toAuthError(), this)
